import { PageWidget } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import { BreadCrumb as PrimeBreadCrumb } from 'primereact/breadcrumb'

export const BreadCrumbClickableItemTemplate = (props: { label: string; command?: () => void; disabled?: boolean }) =>
  props.command ? (
    <a
      href='#'
      onClick={(e) => {
        e.preventDefault()
        if (!props.disabled && props.command) props.command()
      }}
      className={`text-[var(--primary-color)] hover:text-[var(--primary-600)] ${props.disabled ? 'cursor-default opacity-60' : ''}`}
      role='link'
      aria-disabled={props.disabled}
    >
      {props.label}
    </a>
  ) : (
    props.label
  )

export const BreadCrumbCurrentItemTemplate = (props: { label: string }) => <span>{props.label}</span>

export function BreadCrumb() {
  const context = useWebAppContext()

  return (
    context.breadCrumbItems &&
    context.breadCrumbItems.length > 0 && (
      <PageWidget childrenDefaultClassNames='pt-1'>
        <PrimeBreadCrumb
          pt={{
            root: {
              className: 'border-0 pb-1 pt-[5px]',
            },
          }}
          model={context?.breadCrumbItems}
        />
      </PageWidget>
    )
  )
}
